/* eslint-disable camelcase */
import axios from 'axios';
import * as types from '../constants/ActionTypes';
import domains from '../containers/Domains';
import { api as apiBuilder } from '../utils/apiBuilder';
import { getIdToken } from '../services/ServiceManager';

const config = {
  instagramAppId: '72654d9da76d410ea3d48f761b3dac89',
  facebookAppId: domains.alexiaAppId,
  redirectUri: `${window.location.origin}/share/settings`
};

export const fetchLob = (user_id) => async (dispatch) => {
  dispatch({
    type: types.AD_SHARE_FETCH_LOB
  });
  try {
    const url = apiBuilder.buildApi('share/ad');
    const response = await axios({
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        query: 'all',
        user_id
      })
    });
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_SUCCESS,
      data: response.data.data
    });
  } catch (e) {
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_ERROR,
      error: e.response
    });
  }
};

export const fetchPost = async (
  access_token,
  lob_key,
  account_key,
  type
) => async (dispatch) => {
  dispatch({
    type: types.AD_SHARE_FETCH_POST
  });

  try {
    let url = '';
    switch (type) {
      case 'instagram':
        url = `${apiBuilder.buildApi(
          'instagram'
        )}?access_token=${access_token}`;
        break;
      case 'facebook':
        url = `${apiBuilder.buildApi(
          'facebook'
        )}?access_token=${access_token}&type=content&page_id=${account_key}&results=5`;
        break;
      default:
        throw new Error('The type is invalid.');
    }

    // the response for axios is different than fetch so we can't use makeGet for this
    const token = await new Promise(async (resolve, reject) => {
      await getIdToken().then(async (result) => resolve(result));
      reject(null);
    });

    const response = await axios.get(url, {
      headers: { AlexiaAuth: token }
    });

    dispatch({
      type: types.AD_SHARE_FETCH_POST_SUCCESS,
      data: response.data.data,
      lob_key,
      account_key
    });
  } catch (e) {
    dispatch({
      type: types.AD_SHARE_FETCH_POST_ERROR,
      error: e.response
    });
  }
};

export const insertLob = (lob_name, user_id) => async (dispatch) => {
  dispatch({
    type: types.AD_SHARE_FETCH_LOB
  });

  const url = apiBuilder.buildApi('share/ad');
  try {
    const response = await axios({
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        query: 'insertLob',
        lob_name,
        user_id
      })
    });
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_SUCCESS,
      data: response.data.data
    });
  } catch (e) {
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_ERROR,
      error: e.response
    });
  }
};

export const insertLobAccount = (account) => async (dispatch) => {
  dispatch({
    type: types.AD_SHARE_FETCH_LOB
  });

  const url = apiBuilder.buildApi('share/ad');
  try {
    await axios({
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        query: 'insertAccount',
        data: {
          lob_key: account.lob,
          access_token: account.access_token,
          type: account.type,
          page_id: account.page ? account.page : false,
          account_user_id: account.user.id,
          account_username: account.user.username
        }
      })
    });
  } catch (e) {
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_ERROR,
      error: e.response
    });
  }
};

export const removeAccount = (lob_id, account_id) => async (dispatch) => {
  dispatch({
    type: types.AD_SHARE_FETCH_LOB
  });

  const url = apiBuilder.buildApi('share/ad');
  try {
    const response = await axios({
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        query: 'deleteAccount',
        lob_id,
        account_id
      })
    });
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_SUCCESS,
      data: response.data.data
    });
  } catch (e) {
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_ERROR,
      error: e.response
    });
  }
};

export const removeLob = (lob_id) => async (dispatch) => {
  dispatch({
    type: types.AD_SHARE_FETCH_LOB
  });

  const url = apiBuilder.buildApi('share/ad');
  try {
    const response = await axios({
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        query: 'deleteLob',
        lob_id
      })
    });
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_SUCCESS,
      data: response.data.data
    });
  } catch (e) {
    dispatch({
      type: types.AD_SHARE_FETCH_LOB_ERROR,
      error: e.response
    });
  }
};

export const loginInstagram = () => {
  window.location.href = `https://api.instagram.com/oauth/authorize/?client_id=${
    config.instagramAppId
  }&redirect_uri=${config.redirectUri}&response_type=code`;
};

export const loginFacebook = () => {
  window.location.href = `https://www.facebook.com/v3.2/dialog/oauth?client_id=${
    config.facebookAppId
  }&redirect_uri=${config.redirectUri}&scope=email,user_posts,manage_pages`;
};



// WEBPACK FOOTER //
// ./src/actions/AdShareActions.js